var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBgSlowMeteora(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Slow_BG_-Buildings",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 6131 1800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        fill: #181216;\n      }\n\n      .cls-3 {\n        fill: #ac22b3;\n      }\n\n      .cls-4 {\n        fill: #1c151a;\n      }\n\n      .cls-5 {\n        fill: #008d9b;\n      }\n\n      .cls-6 {\n        fill: #9c9c9c;\n      }\n\n      .cls-7 {\n        fill: #9d991e;\n      }\n\n      .cls-8 {\n        fill: #b3af22;\n      }\n\n      .cls-9 {\n        fill: #008b99;\n      }\n\n      .cls-10 {\n        fill: #181217;\n      }\n\n      .cls-11 {\n        fill: #008e9c;\n      }\n\n      .cls-12 {\n        fill: #322930;\n      }\n\n      .cls-13 {\n        fill: #931d99;\n      }\n\n      .cls-14 {\n        fill: #4a8285;\n      }\n\n      .cls-15 {\n        fill: #4c8688;\n      }\n\n      .cls-16 {\n        isolation: isolate;\n      }\n\n      .cls-17 {\n        fill: #2cb314;\n      }\n\n      .cls-18 {\n        fill: #269911;\n      }\n\n      .cls-19 {\n        clip-path: url(#clippath-17);\n      }\n\n      .cls-20 {\n        clip-path: url(#clippath-19);\n      }\n\n      .cls-21 {\n        clip-path: url(#clippath-11);\n      }\n\n      .cls-22 {\n        clip-path: url(#clippath-16);\n      }\n\n      .cls-23 {\n        clip-path: url(#clippath-18);\n      }\n\n      .cls-24 {\n        clip-path: url(#clippath-10);\n      }\n\n      .cls-25 {\n        clip-path: url(#clippath-15);\n      }\n\n      .cls-26 {\n        clip-path: url(#clippath-13);\n      }\n\n      .cls-27 {\n        clip-path: url(#clippath-14);\n      }\n\n      .cls-28 {\n        clip-path: url(#clippath-12);\n      }\n\n      .cls-29 {\n        clip-path: url(#clippath-60);\n      }\n\n      .cls-30 {\n        clip-path: url(#clippath-50);\n      }\n\n      .cls-31 {\n        clip-path: url(#clippath-55);\n      }\n\n      .cls-32 {\n        clip-path: url(#clippath-52);\n      }\n\n      .cls-33 {\n        clip-path: url(#clippath-57);\n      }\n\n      .cls-34 {\n        clip-path: url(#clippath-54);\n      }\n\n      .cls-35 {\n        clip-path: url(#clippath-56);\n      }\n\n      .cls-36 {\n        clip-path: url(#clippath-53);\n      }\n\n      .cls-37 {\n        clip-path: url(#clippath-51);\n      }\n\n      .cls-38 {\n        clip-path: url(#clippath-58);\n      }\n\n      .cls-39 {\n        clip-path: url(#clippath-59);\n      }\n\n      .cls-40 {\n        clip-path: url(#clippath-31);\n      }\n\n      .cls-41 {\n        clip-path: url(#clippath-32);\n      }\n\n      .cls-42 {\n        clip-path: url(#clippath-33);\n      }\n\n      .cls-43 {\n        clip-path: url(#clippath-34);\n      }\n\n      .cls-44 {\n        clip-path: url(#clippath-35);\n      }\n\n      .cls-45 {\n        clip-path: url(#clippath-39);\n      }\n\n      .cls-46 {\n        clip-path: url(#clippath-30);\n      }\n\n      .cls-47 {\n        clip-path: url(#clippath-36);\n      }\n\n      .cls-48 {\n        clip-path: url(#clippath-37);\n      }\n\n      .cls-49 {\n        clip-path: url(#clippath-38);\n      }\n\n      .cls-50 {\n        clip-path: url(#clippath-27);\n      }\n\n      .cls-51 {\n        clip-path: url(#clippath-29);\n      }\n\n      .cls-52 {\n        clip-path: url(#clippath-26);\n      }\n\n      .cls-53 {\n        clip-path: url(#clippath-28);\n      }\n\n      .cls-54 {\n        clip-path: url(#clippath-20);\n      }\n\n      .cls-55 {\n        clip-path: url(#clippath-21);\n      }\n\n      .cls-56 {\n        clip-path: url(#clippath-22);\n      }\n\n      .cls-57 {\n        clip-path: url(#clippath-23);\n      }\n\n      .cls-58 {\n        clip-path: url(#clippath-24);\n      }\n\n      .cls-59 {\n        clip-path: url(#clippath-25);\n      }\n\n      .cls-60 {\n        clip-path: url(#clippath-41);\n      }\n\n      .cls-61 {\n        clip-path: url(#clippath-42);\n      }\n\n      .cls-62 {\n        clip-path: url(#clippath-43);\n      }\n\n      .cls-63 {\n        clip-path: url(#clippath-44);\n      }\n\n      .cls-64 {\n        clip-path: url(#clippath-45);\n      }\n\n      .cls-65 {\n        clip-path: url(#clippath-49);\n      }\n\n      .cls-66 {\n        clip-path: url(#clippath-40);\n      }\n\n      .cls-67 {\n        clip-path: url(#clippath-46);\n      }\n\n      .cls-68 {\n        clip-path: url(#clippath-47);\n      }\n\n      .cls-69 {\n        clip-path: url(#clippath-48);\n      }\n\n      .cls-70 {\n        fill: #279c12;\n      }\n\n      .cls-71 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-72 {\n        clip-path: url(#clippath-3);\n      }\n\n      .cls-73 {\n        clip-path: url(#clippath-4);\n      }\n\n      .cls-74 {\n        clip-path: url(#clippath-2);\n      }\n\n      .cls-75 {\n        clip-path: url(#clippath-7);\n      }\n\n      .cls-76 {\n        clip-path: url(#clippath-6);\n      }\n\n      .cls-77 {\n        clip-path: url(#clippath-9);\n      }\n\n      .cls-78 {\n        clip-path: url(#clippath-8);\n      }\n\n      .cls-79 {\n        clip-path: url(#clippath-5);\n      }\n\n      .cls-80 {\n        fill: #3fff1d;\n      }\n\n      .cls-81 {\n        fill: #9c981e;\n      }\n\n      .cls-82 {\n        fill: #961e9c;\n      }\n\n      .cls-83 {\n        fill: #3d2b38;\n      }\n\n      .cls-84 {\n        fill: #aaa548;\n      }\n\n      .cls-85 {\n        fill: #99961d;\n      }\n\n      .cls-86 {\n        fill: #008c9b;\n      }\n\n      .cls-87 {\n        fill: #918d3d;\n      }\n\n      .cls-88 {\n        fill: #57999b;\n      }\n\n      .cls-89 {\n        fill: #191217;\n      }\n\n      .cls-90 {\n        fill: #b3b3b3;\n      }\n\n      .cls-91 {\n        fill: #352531;\n      }\n\n      .cls-92 {\n        fill: #9c991e;\n      }\n\n      .cls-93 {\n        fill: #332931;\n      }\n\n      .cls-94 {\n        fill: #941e9a;\n      }\n\n      .cls-95 {\n        fill: #928e3e;\n      }\n\n      .cls-96 {\n        fill: #00a2b3;\n      }\n\n      .cls-97 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-98 {\n        fill: #961e9d;\n      }\n\n      .cls-99 {\n        fill: #362632;\n      }\n\n      .cls-100 {\n        fill: #999;\n      }\n\n      .cls-101 {\n        fill: #951e9b;\n      }\n\n      .cls-102 {\n        fill: #392f37;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5861.4,684.44c0-2.8-1.07-5.34-2.79-7.18,1.8,0,4.2,0,5.99,0h45.31c1.73,1.84,2.79,4.38,2.79,7.18-15.39,0-35.91,0-51.3,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5858.6,677.26s0,0,0,0c1.8,0,4.2,0,6.01,0h45.3s0,0,0,0c-1.8,0-4.19,0-5.99,0h-39.32c-1.8,0-4.2,0-5.99,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5903.15,1147.7h-51.3c5.27,0,9.55-4.55,9.55-10.16h51.3c0,5.61-4.28,10.16-9.55,10.16Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5858.59,677.25c-1.73-1.84-4.11-2.97-6.74-2.97,17.1,0,34.2,0,51.3,0,2.63,0,5.02,1.14,6.74,2.97-1.8,0-4.19,0-5.98,0h-39.31c-1.8,0-4.2,0-6.01,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5888.21,1147.71h-51.3c-5.28,0-9.56-4.55-9.56-10.16h51.3c0,5.61,4.28,10.16,9.56,10.16Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5878.65,684.44h-51.3c0-5.61,4.28-10.16,9.56-10.16h51.3c-5.28,0-9.56,4.55-9.56,10.16Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5791.77,428.22c.46,0,1.08,0,1.55,0h49.76c5.78,3.94,11.25,8.6,16.3,13.98,30.16,32.09,36.36,80.18,18.59,118.85-1.8,0-4.19,0-5.99,0h-45.31c17.77-38.67,11.57-86.76-18.59-118.85-5.05-5.37-10.52-10.03-16.3-13.98Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5791.29,720.09c0-2.81-1.07-5.35-2.8-7.19,1.8,0,4.2,0,5.99,0h45.31c1.73,1.84,2.8,4.38,2.8,7.19-15.39,0-35.91,0-51.3,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5788.5,712.9s0,0,0,0c1.8,0,4.2,0,6,0h45.3s0,0,0,0c-1.8,0-4.19,0-5.99,0h-39.32c-1.8,0-4.2,0-5.99,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5833.05,1147.7h-51.3c5.27,0,9.55-4.55,9.55-10.16h51.3c0,5.61-4.28,10.16-9.55,10.16Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5788.49,712.89c-1.73-1.84-4.11-2.98-6.75-2.98h51.3s.02,0,.03,0c-1.79,0-4.17,0-5.96,0h-45.08,51.04c2.62,0,5,1.14,6.72,2.98-1.8,0-4.19,0-5.98,0h-39.32c-1.8,0-4.2,0-6,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5818.11,1147.71h-51.3c-5.28,0-9.56-4.55-9.56-10.16h51.3c0,5.61,4.28,10.16,9.56,10.16Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5808.55,720.09h-51.3c0-5.62,4.28-10.17,9.56-10.17h51.3c-5.28,0-9.56,4.55-9.56,10.17Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5808.06,588.71c7.8-8.3,13.99-17.67,18.59-27.66,1.8,0,4.2,0,5.99,0h45.31c-4.59,10-10.79,19.36-18.59,27.66-18.39,19.57-42.84,30.34-68.84,30.34h-51.3c26,0,50.44-10.77,68.84-30.34Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5790.53,618.3h-51.3c38.17,0,71.16-23.55,86.86-57.74h51.3c-15.7,34.19-48.7,57.74-86.86,57.74Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-15"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5791.77,428.22c-15.94-10.88-34.24-16.32-52.54-16.32h51.3c18.3,0,36.6,5.44,52.54,16.32-1.33,0-3.11,0-4.45,0h-45.31c-.46,0-1.08,0-1.55,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5869.75,560.56h-51.3c18.16-36.17,12.93-82.24-15.7-112.71-17.51-18.64-40.52-27.95-63.52-27.95h51.3c23,0,46.01,9.32,63.52,27.95,28.63,30.46,33.86,76.54,15.7,112.71Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5739.21,419.89s.01,0,.02,0h51.3s-.01,0-.02,0c-1.8,0-4.19,0-5.99,0h-39.32c-1.8,0-4.2,0-5.99,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5721.19,720.09c0-2.81-1.07-5.35-2.8-7.19,1.8,0,4.2,0,5.99,0h45.31c1.73,1.84,2.8,4.38,2.8,7.19-15.39,0-35.91,0-51.3,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5718.4,712.9s0,0,0,0c1.8,0,4.2,0,6,0h45.3s0,0,0,0c-1.8,0-4.19,0-5.99,0h-39.32c-1.8,0-4.2,0-5.99,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-20"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5762.95,1147.7h-51.3c5.27,0,9.55-4.55,9.55-10.16h51.3c0,5.61-4.28,10.16-9.55,10.16Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-21"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5718.39,712.89c-1.73-1.84-4.11-2.98-6.75-2.98h51.3s.02,0,.03,0c-1.79,0-4.17,0-5.96,0h-45.08,51.04c2.62,0,5,1.14,6.72,2.98-1.8,0-4.19,0-5.98,0h-39.32c-1.8,0-4.2,0-6,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-22"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5748.01,1147.71h-51.3c-5.28,0-9.55-4.55-9.55-10.16h51.3c0,5.61,4.27,10.16,9.55,10.16Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-23"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5738.46,720.09h-51.3c0-5.62,4.27-10.17,9.55-10.17h51.3c-5.28,0-9.55,4.55-9.55,10.17Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-24"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5790.53,618.3h-51.3c-38.17,0-71.16-23.55-86.86-57.74h51.3c15.7,34.19,48.7,57.74,86.86,57.74Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-25"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5670.38,588.72c-7.8-8.3-13.99-17.67-18.59-27.66,1.8,0,4.2,0,5.99,0h45.31c4.59,10,10.79,19.36,18.59,27.66,18.39,19.57,42.84,30.34,68.84,30.34h-51.3c-26.01,0-50.46-10.77-68.84-30.34Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-26"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5651.09,684.44c0-2.8-1.07-5.34-2.79-7.18,1.8,0,4.2,0,5.99,0h45.31c1.73,1.84,2.79,4.38,2.79,7.18-15.39,0-35.91,0-51.3,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-27"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5648.3,677.26s0,0,0,0c1.8,0,4.2,0,6.01,0h45.3s0,0,0,0c-1.8,0-4.19,0-5.99,0h-39.32c-1.8,0-4.2,0-5.99,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-28"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5675.69,447.85c17.51-18.63,40.51-27.95,63.52-27.95,1.8,0,4.2,0,5.99,0h45.31c-23,0-46.01,9.32-63.52,27.95-28.62,30.46-33.85,76.54-15.69,112.71h-51.3c-18.15-36.17-12.93-82.24,15.69-112.71Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-29"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5692.85,1147.7h-51.3c5.27,0,9.55-4.55,9.55-10.16h51.3c0,5.61-4.28,10.16-9.55,10.16Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-30"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5648.29,677.25c-1.73-1.84-4.11-2.97-6.74-2.97,17.1,0,34.2,0,51.3,0,2.63,0,5.02,1.14,6.74,2.97-1.8,0-4.19,0-5.98,0h-39.31c-1.8,0-4.2,0-6.01,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-31"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5670.38,442.2c18.98-20.2,43.91-30.3,68.84-30.3h51.3c-24.93,0-49.86,10.1-68.84,30.3-30.16,32.09-36.35,80.19-18.59,118.86-1.8,0-4.19,0-5.99,0h-45.31c-17.77-38.67-11.57-86.76,18.59-118.86Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-32"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5685.1,330.76h-51.3c29.88-22.2,66.22-35.23,105.43-35.23h51.3c-39.21,0-75.55,13.03-105.43,35.23Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-33"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5677.9,1147.71h-51.3c-5.28,0-9.55-4.55-9.55-10.16h51.3c0,5.61,4.27,10.16,9.55,10.16Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-34"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5668.36,684.44h-51.3c0-5.61,4.27-10.16,9.55-10.16h51.3c-5.28,0-9.55,4.55-9.55,10.16Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-35"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1147.29,372.93h-51.3c0-68.28-24.99-132.48-70.36-180.76-45.37-48.29-105.7-74.88-169.86-74.88h51.3c64.16,0,124.49,26.6,169.86,74.88,45.37,48.28,70.36,112.48,70.36,180.76Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-36"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M739.58,1349.2h-51.3c3.63,0,6.58-3.14,6.58-7h51.3c0,3.86-2.94,7-6.58,7Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-37"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M694.86,1331.25c0-3.86-2.94-7.01-6.58-7.01h51.3s.05,0,.08,0c-1.76,0-4.12,0-5.88,0h-45.06,50.94c3.6.04,6.5,3.17,6.5,7.01-15.39,0-35.91,0-51.3,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-38"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M722.84,1245.66h-51.3c3.63,0,6.58-3.13,6.58-7h51.3c0,3.87-2.94,7-6.58,7Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-39"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M678.11,1227.71c0-3.86-2.94-6.99-6.58-6.99h.36s50.94,0,50.94,0c3.63,0,6.58,3.13,6.58,6.99-15.39,0-35.91,0-51.3,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-40"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M654.79,1142.11c3.63,0,6.58-3.13,6.58-7h51.3c0,3.87-2.94,7-6.58,7-15.39,0-35.91,0-51.3,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-41"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M661.37,1124.17c0-3.87-2.94-7-6.58-7h.36s50.94,0,50.94,0c3.63,0,6.58,3.13,6.58,7-15.39,0-35.91,0-51.3,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-42"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M644.62,1031.65s0-.05,0-.08h51.3s0,.05,0,.08c-1.77,0-4.13,0-5.9,0h-39.39c-1.8,0-4.21,0-6.02,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-43"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M638.04,1038.57c3.6,0,6.54-3.08,6.58-6.92,1.8,0,4.21,0,6.02,0h45.29c-.04,3.84-2.98,6.92-6.58,6.92-15.39,0-35.91,0-51.3,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-44"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M644.63,1020.62c0-3.87-2.96-7-6.58-7h.36s50.94,0,50.94,0c3.63,0,6.58,3.13,6.58,7h-50.94c-.11,0-.25,0-.36,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-45"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M621.3,935.02c3.63,0,6.58-3.13,6.58-6.99h51.3c0,3.86-2.95,6.99-6.58,6.99-15.39,0-35.91,0-51.3,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-46"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M627.87,917.08c0-3.87-2.95-7-6.58-7h.36s50.94,0,50.94,0c3.63,0,6.58,3.13,6.58,7-15.39,0-35.91,0-51.3,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-47"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M604.55,831.49c3.63,0,6.57-3.14,6.57-7h.36s50.94,0,50.94,0c0,3.86-2.94,7-6.57,7-15.39,0-35.91,0-51.3,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-48"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M611.12,813.53c0-3.86-2.94-7-6.57-7h.36s50.94,0,50.94,0c3.63,0,6.57,3.14,6.57,7h-50.94c-.11,0-.25,0-.36,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-49"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M441.25,1349.21h-51.3c-3.64,0-6.58-3.14-6.58-7h51.3c0,3.86,2.94,7,6.58,7Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-50"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M434.67,1331.25h-51.3c0-3.86,2.94-7,6.58-7h51.3c-3.64,0-6.58,3.14-6.58,7Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-51"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M441.25,1245.66h-51.3c-3.64,0-6.58-3.13-6.58-7h51.3c0,3.87,2.94,7,6.58,7Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-52"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M434.67,1227.71h-51.3c0-3.86,2.94-6.99,6.58-6.99h51.3c-3.64,0-6.58,3.13-6.58,6.99Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-53"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M441.25,1142.12h-51.3c-3.64,0-6.58-3.13-6.58-7h51.3c0,3.87,2.94,7,6.58,7Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-54"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M434.67,1124.17h-51.3c0-3.87,2.94-7,6.58-7h51.3c-3.64,0-6.58,3.13-6.58,7Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-55"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M441.25,1038.57h-51.3c-3.64,0-6.58-3.13-6.58-7h51.3c0,3.87,2.94,7,6.58,7Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-56"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M434.67,1020.63h-51.3c0-3.87,2.94-7,6.58-7h51.3c-3.64,0-6.58,3.13-6.58,7Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-57"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M441.25,935.03h-51.3c-3.64,0-6.58-3.13-6.58-6.99h51.3c0,3.86,2.94,6.99,6.58,6.99Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-58"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M434.67,917.08h-51.3c0-3.87,2.94-7,6.58-7h51.3c-3.64,0-6.58,3.13-6.58,7Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-59"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M441.25,831.49h-51.3c-3.64,0-6.58-3.14-6.58-7h51.3c0,3.86,2.94,7,6.58,7Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-60"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M434.67,813.54h-51.3c0-3.86,2.94-7,6.58-7h51.3c-3.64,0-6.58,3.14-6.58,7Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "5974.9 1222.34 5923.6 1222.34 5957.95 1222.34 6009.26 1222.34 5974.9 1222.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-85",
    points: "5974.91 470.06 5923.6 470.06 5923.18 207.61 5974.48 207.61 5974.91 470.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "5974.48 207.61 5986.78 215.03 5986.78 470.06 5974.91 470.06 5974.48 207.61"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 5861.4,
    y: 684.44,
    width: 51.3,
    height: 453.11
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-97"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M5912.7,684.44h-51.3c0-5.61-4.28-10.16-9.55-10.16h51.3c5.27,0,9.55,4.55,9.55,10.16"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-71"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M5912.7,684.44h-51.3c0-5.61-4.28-10.16-9.55-10.16h51.3c5.27,0,9.55,4.55,9.55,10.16"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-74"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M5903.15,1147.7h-51.3c5.27,0,9.55-4.55,9.55-10.16h51.3c0,5.61-4.28,10.16-9.55,10.16"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-72"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M5912.7,684.44h-51.3c0-5.61-4.28-10.16-9.55-10.16h51.3c5.27,0,9.55,4.55,9.55,10.16"
  })))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 5844.65,
    y: 154.44,
    width: 51.3,
    height: 176.32
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-92",
    points: "5888.21 674.28 5836.91 674.28 5851.85 674.28 5903.15 674.28 5888.21 674.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "5888.21 1147.7 5836.9 1147.7 5851.85 1147.7 5903.15 1147.7 5888.21 1147.7"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-73"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M5888.21,1147.71h-51.3c-5.28,0-9.56-4.55-9.56-10.16h51.3c0,5.61,4.28,10.16,9.56,10.16"
  })))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-85",
    x: 5827.35,
    y: 684.44,
    width: 51.3,
    height: 453.11
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-79"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M5878.65,684.44h-51.3c0-5.61,4.28-10.16,9.56-10.16h51.3c-5.28,0-9.56,4.55-9.56,10.16"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-76"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M5790.53,619.05h-51.3c26,0,50.44-10.77,68.84-30.34,37.96-40.4,37.96-106.13,0-146.52-18.98-20.2-43.91-30.3-68.84-30.3h51.3c24.93,0,49.86,10.1,68.84,30.3,37.96,40.39,37.96,106.12,0,146.52-18.39,19.57-42.84,30.34-68.84,30.34"
  })))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 5791.29,
    y: 720.09,
    width: 51.3,
    height: 417.46
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-75"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M5842.6,720.09h-51.3c0-5.61-4.28-10.17-9.55-10.17h51.3c5.27,0,9.55,4.56,9.55,10.17"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-78"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M5842.6,720.09h-51.3c0-5.61-4.28-10.17-9.55-10.17h51.3c5.27,0,9.55,4.56,9.55,10.17"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-77"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M5833.05,1147.7h-51.3c5.27,0,9.55-4.55,9.55-10.16h51.3c0,5.61-4.28,10.16-9.55,10.16"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-24"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M5842.6,720.09h-51.3c0-5.61-4.28-10.17-9.55-10.17h51.3c5.27,0,9.55,4.56,9.55,10.17"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-92",
    points: "5818.11 709.92 5766.81 709.92 5781.75 709.92 5833.05 709.92 5818.11 709.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "5818.1 1147.7 5766.8 1147.7 5781.75 1147.7 5833.05 1147.7 5818.1 1147.7"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M5818.11,1147.71h-51.3c-5.28,0-9.56-4.55-9.56-10.16h51.3c0,5.61,4.28,10.16,9.56,10.16"
  })))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-85",
    x: 5757.25,
    y: 720.09,
    width: 51.3,
    height: 417.46
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-28"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M5808.55,720.09h-51.3c0-5.62,4.28-10.17,9.56-10.17h51.3c-5.28,0-9.56,4.55-9.56,10.17"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M5833.05,709.92c5.27,0,9.55,4.55,9.55,10.17v417.46c0,5.61-4.28,10.16-9.55,10.16h-14.94c-5.28,0-9.56-4.55-9.56-10.16v-417.46c0-5.62,4.28-10.17,9.56-10.17h14.94Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-26"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M5790.53,619.05h-51.3c26,0,50.44-10.77,68.84-30.34,37.96-40.4,37.96-106.13,0-146.52-18.98-20.2-43.91-30.3-68.84-30.3h51.3c24.93,0,49.86,10.1,68.84,30.3,37.96,40.39,37.96,106.12,0,146.52-18.39,19.57-42.84,30.34-68.84,30.34"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-27"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M5790.53,618.3h-51.3c38.17,0,71.16-23.55,86.86-57.74h51.3c-15.7,34.19-48.7,57.74-86.86,57.74"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M5790.53,619.05h-51.3c26,0,50.44-10.77,68.84-30.34,37.96-40.4,37.96-106.13,0-146.52-18.98-20.2-43.91-30.3-68.84-30.3h51.3c24.93,0,49.86,10.1,68.84,30.3,37.96,40.39,37.96,106.12,0,146.52-18.39,19.57-42.84,30.34-68.84,30.34"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-22"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M5869.75,560.56h-51.3c18.16-36.17,12.93-82.24-15.7-112.71-17.51-18.64-40.52-27.95-63.52-27.95h51.3c23,0,46.01,9.32,63.52,27.95,28.63,30.46,33.86,76.54,15.7,112.71"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M5711.3,560.55h-51.3c-18.15-36.17-12.93-82.24,15.69-112.71,17.51-18.64,40.53-27.95,63.53-27.95h51.3c-23.01,0-46.02,9.31-63.53,27.95-28.62,30.46-33.85,76.54-15.69,112.71"
  })))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 5721.19,
    y: 720.09,
    width: 51.3,
    height: 417.46
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M5772.49,720.09h-51.3c0-5.61-4.28-10.17-9.55-10.17h51.3c5.27,0,9.55,4.56,9.55,10.17"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-20"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M5772.49,720.09h-51.3c0-5.61-4.28-10.17-9.55-10.17h51.3c5.27,0,9.55,4.56,9.55,10.17"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-54"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M5762.95,1147.7h-51.3c5.27,0,9.55-4.55,9.55-10.16h51.3c0,5.61-4.28,10.16-9.55,10.16"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-55"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M5772.49,720.09h-51.3c0-5.61-4.28-10.17-9.55-10.17h51.3c5.27,0,9.55,4.56,9.55,10.17"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-92",
    points: "5748.01 709.92 5696.7 709.92 5711.65 709.92 5762.95 709.92 5748.01 709.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "5748 1147.7 5696.7 1147.7 5711.64 1147.7 5762.95 1147.7 5748 1147.7"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-56"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M5748.01,1147.71h-51.3c-5.28,0-9.55-4.55-9.55-10.16h51.3c0,5.61,4.27,10.16,9.55,10.16"
  })))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-85",
    x: 5687.15,
    y: 720.09,
    width: 51.3,
    height: 417.46
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-57"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M5738.46,720.09h-51.3c0-5.62,4.27-10.17,9.55-10.17h51.3c-5.28,0-9.55,4.55-9.55,10.17"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M5762.95,709.92c5.27,0,9.55,4.55,9.55,10.17v417.46c0,5.61-4.28,10.16-9.55,10.16h-14.94c-5.28,0-9.55-4.55-9.55-10.16v-417.46c0-5.62,4.27-10.17,9.55-10.17h14.94Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-92",
    points: "5711.3 560.56 5660 560.56 5818.45 560.56 5869.75 560.56 5711.3 560.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-92",
    points: "5703.66 560.56 5652.36 560.56 5660 560.56 5711.3 560.56 5703.66 560.56"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-58"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M5790.53,618.3h-51.3c-38.17,0-71.16-23.55-86.86-57.74h51.3c15.7,34.19,48.7,57.74,86.86,57.74"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M5877.39,560.56c-15.7,34.19-48.7,57.74-86.86,57.74-38.17,0-71.16-23.55-86.86-57.74h7.64s158.45,0,158.45,0h7.64Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-59"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M5790.53,619.06h-51.3c-26.01,0-50.46-10.77-68.84-30.34-37.96-40.4-37.96-106.13,0-146.52,18.98-20.2,43.91-30.3,68.84-30.3h51.3c-24.93,0-49.86,10.1-68.84,30.3-37.96,40.39-37.96,106.12,0,146.52,18.39,19.57,42.84,30.34,68.84,30.34"
  })))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 5651.09,
    y: 684.44,
    width: 51.3,
    height: 453.11
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-52"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M5702.39,684.44h-51.3c0-5.61-4.28-10.16-9.55-10.16h51.3c5.27,0,9.55,4.55,9.55,10.16"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-50"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M5702.39,684.44h-51.3c0-5.61-4.28-10.16-9.55-10.16h51.3c5.27,0,9.55,4.55,9.55,10.16"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-53"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M5711.3,560.55h-51.3c-18.15-36.17-12.93-82.24,15.69-112.71,17.51-18.64,40.53-27.95,63.53-27.95h51.3c-23.01,0-46.02,9.31-63.53,27.95-28.62,30.46-33.85,76.54-15.69,112.71"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-51"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M5692.85,1147.7h-51.3c5.27,0,9.55-4.55,9.55-10.16h51.3c0,5.61-4.28,10.16-9.55,10.16"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-46"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M5702.39,684.44h-51.3c0-5.61-4.28-10.16-9.55-10.16h51.3c5.27,0,9.55,4.55,9.55,10.16"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-40"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M5790.53,619.06h-51.3c-26.01,0-50.46-10.77-68.84-30.34-37.96-40.4-37.96-106.13,0-146.52,18.98-20.2,43.91-30.3,68.84-30.3h51.3c-24.93,0-49.86,10.1-68.84,30.3-37.96,40.39-37.96,106.12,0,146.52,18.39,19.57,42.84,30.34,68.84,30.34"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-41"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M5685.1,330.76h-51.3c29.88-22.2,66.22-35.23,105.43-35.23h51.3c-39.21,0-75.55,13.03-105.43,35.23"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-92",
    points: "5677.9 674.28 5626.6 674.28 5641.54 674.28 5692.85 674.28 5677.9 674.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "5677.9 1147.7 5626.6 1147.7 5641.54 1147.7 5692.85 1147.7 5677.9 1147.7"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-42"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M5677.9,1147.71h-51.3c-5.28,0-9.55-4.55-9.55-10.16h51.3c0,5.61,4.27,10.16,9.55,10.16"
  })))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-85",
    x: 5617.05,
    y: 684.44,
    width: 51.3,
    height: 453.11
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M5692.85,674.28c5.27,0,9.55,4.55,9.55,10.16v453.11c0,5.61-4.28,10.16-9.55,10.16h-14.94c-5.28,0-9.55-4.55-9.55-10.16v-453.11c0-5.61,4.27-10.16,9.55-10.16h14.94Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-43"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M5668.36,684.44h-51.3c0-5.61,4.27-10.16,9.55-10.16h51.3c-5.28,0-9.55,4.55-9.55,10.16"
  })))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 5554.85,
    y: 1477.19,
    width: 51.3,
    height: 324.33
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M5974.9,989.79v232.55h34.35s0,254.85,0,254.85h-34.35v324.33h-368.75s0-324.33,0-324.33h-38.83s0-254.85,0-254.85h38.83v-232.55l-57.24-519.22h57.24s.9-263.28.9-263.28l78.05-52.86v176.32c29.88-22.2,66.22-35.23,105.43-35.23,39.21,0,75.55,13.03,105.43,35.23v-176.32l78.52,53.18v262.45l57.66.51-57.23,519.22ZM5790.53,619.05c26,0,50.44-10.77,68.84-30.34,37.96-40.4,37.96-106.13,0-146.52-18.98-20.2-43.91-30.3-68.84-30.3-24.93,0-49.86,10.1-68.84,30.3-37.96,40.39-37.96,106.12,0,146.52,18.38,19.57,42.84,30.34,68.84,30.34M5912.7,1137.54v-453.11c0-5.61-4.28-10.16-9.55-10.16h-14.95c-5.28,0-9.56,4.55-9.56,10.16v453.11c0,5.61,4.28,10.16,9.56,10.16h14.95c5.27,0,9.55-4.55,9.55-10.16M5702.39,1137.54v-453.11c0-5.61-4.28-10.16-9.55-10.16h-14.95c-5.28,0-9.55,4.55-9.55,10.16v453.11c0,5.61,4.27,10.16,9.55,10.16h14.95c5.27,0,9.55-4.55,9.55-10.16M5842.6,1137.54v-417.46c0-5.61-4.28-10.17-9.55-10.17h-14.95c-5.28,0-9.56,4.56-9.56,10.17v417.46c0,5.61,4.28,10.16,9.56,10.16h14.95c5.27,0,9.55-4.55,9.55-10.16M5772.49,1137.54v-417.46c0-5.61-4.28-10.17-9.55-10.17h-14.95c-5.28,0-9.55,4.56-9.55,10.17v417.46c0,5.61,4.27,10.16,9.55,10.16h14.95c5.27,0,9.55-4.55,9.55-10.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M5903.15,674.28c5.27,0,9.55,4.55,9.55,10.16v453.11c0,5.61-4.28,10.16-9.55,10.16h-14.94c-5.28,0-9.56-4.55-9.56-10.16v-453.11c0-5.61,4.28-10.16,9.56-10.16h14.94Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-92",
    points: "5869.75 560.56 5818.45 560.56 5826.09 560.56 5877.39 560.56 5869.75 560.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M5859.37,442.2c37.96,40.39,37.96,106.12,0,146.52-18.39,19.57-42.84,30.34-68.84,30.34-26.01,0-50.46-10.77-68.84-30.34-37.96-40.4-37.96-106.13,0-146.52,18.98-20.2,43.91-30.3,68.84-30.3,24.93,0,49.86,10.1,68.84,30.3ZM5790.53,618.3c38.17,0,71.16-23.55,86.86-57.74h-7.64c18.16-36.17,12.93-82.24-15.7-112.71-17.51-18.64-40.52-27.95-63.52-27.95s-46.02,9.32-63.53,27.95c-28.62,30.46-33.85,76.54-15.69,112.71h-7.64c15.71,34.19,48.7,57.74,86.86,57.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M5854.05,447.85c28.63,30.46,33.86,76.54,15.7,112.71h-158.45c-18.15-36.17-12.93-82.24,15.69-112.71,17.51-18.64,40.53-27.95,63.53-27.95,23,0,46,9.31,63.52,27.95Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "5607.05 207.29 5555.75 207.29 5633.8 154.44 5685.1 154.44 5607.05 207.29"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 5554.85,
    y: 989.79,
    width: 51.3,
    height: 232.55
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "5606.15 470.57 5554.85 470.57 5555.75 207.29 5607.05 207.29 5606.15 470.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-81",
    points: "5594.76 215.51 5543.46 215.51 5555.75 207.08 5607.05 207.08 5594.76 215.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "5607.05 207.08 5607.05 470.56 5606.15 470.56 5594.76 470.56 5594.76 215.51 5607.05 207.08"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-85",
    x: 5543.46,
    y: 215.51,
    width: 51.3,
    height: 255.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 5516.01,
    y: 1222.34,
    width: 51.3,
    height: 254.85
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "5567.32 1222.34 5516.01 1222.34 5554.85 1222.34 5606.15 1222.34 5567.32 1222.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "5606.15 989.79 5554.85 989.79 5497.61 470.57 5548.91 470.57 5606.15 989.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "5548.91 470.57 5497.61 470.57 5554.85 470.57 5606.15 470.57 5548.91 470.57"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-102",
    x: 5660.29,
    y: 1259.58,
    width: 296.95,
    height: 184.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 5655.16,
    y: 1259.58,
    width: 5.13,
    height: 184.18
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "5660.29 1259.58 5655.16 1259.58 5952.11 1259.58 5957.24 1259.58 5660.29 1259.58"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-102",
    x: 5662.92,
    y: 1496.65,
    width: 116.63,
    height: 248.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 5657.79,
    y: 1496.65,
    width: 5.13,
    height: 248.88
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "5662.92 1496.65 5657.79 1496.65 5774.41 1496.65 5779.54 1496.65 5662.92 1496.65"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-102",
    x: 5839.33,
    y: 1496.65,
    width: 116.63,
    height: 248.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 5834.2,
    y: 1496.65,
    width: 5.13,
    height: 248.88
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "5839.33 1496.65 5834.2 1496.65 5950.83 1496.65 5955.96 1496.65 5839.33 1496.65"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 3965.14,
    y: 990.79,
    width: 51.3,
    height: 139.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 3965.14,
    y: 881.39,
    width: 51.3,
    height: 81.51
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 3965.14,
    y: 771.97,
    width: 51.3,
    height: 81.53
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "3913.13 600.18 3861.82 600.18 4031.69 600.18 4083 600.18 3913.13 600.18"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 3738,
    y: 1201.06,
    width: 51.3,
    height: 600.15
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "3784.62 561.55 3733.32 561.55 3861.82 561.55 3913.13 561.55 3784.62 561.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "3783.97 600.18 3732.67 600.18 3733.32 561.55 3784.62 561.55 3783.97 600.18"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 3732.67,
    y: 600.18,
    width: 51.3,
    height: 91.07
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-82",
    points: "3482.53 771.97 3431.22 771.97 3965.15 771.97 4016.45 771.97 3482.53 771.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "3443.14 691.25 3391.84 691.25 3732.67 691.25 3783.97 691.25 3443.14 691.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-82",
    points: "3398.79 990.79 3347.49 990.79 3965.15 990.79 4016.45 990.79 3398.79 990.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "3398.79 1130.33 3347.49 1130.33 3965.14 1130.33 4016.45 1130.33 3398.79 1130.33"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 3347.49,
    y: 990.79,
    width: 51.3,
    height: 139.54
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-82",
    points: "3398.79 881.39 3347.49 881.39 3965.15 881.39 4016.45 881.39 3398.79 881.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "3398.79 962.9 3347.49 962.9 3965.14 962.9 4016.45 962.9 3398.79 962.9"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 3398.79,
    y: 881.39,
    width: 617.66,
    height: 81.51
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 3347.49,
    y: 881.39,
    width: 51.3,
    height: 81.51
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "3398.79 853.5 3347.49 853.5 3965.14 853.5 4016.45 853.5 3398.79 853.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "4016.45 771.97 4016.45 853.5 3398.79 853.5 3482.53 771.97 4016.45 771.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-101",
    points: "3398.79 853.5 3347.49 853.5 3431.22 771.97 3482.53 771.97 3398.79 853.5"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 3316.45,
    y: 798.45,
    width: 51.3,
    height: 999.71
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M3913.13,600.18h169.87s0,1201.02,0,1201.02h-293.7s0-600.15,0-600.15h-203.43v600.15h-243.45s25.34-3.05,25.34-3.05v-999.71h-25.34s100.73-107.2,100.73-107.2h340.83v-91.07l.65-38.63h128.5s0,38.63,0,38.63ZM4016.45,1130.33v-139.53h-617.65v139.53h617.65M4016.45,853.5v-81.53h-533.92s-83.73,81.53-83.73,81.53h617.65M4016.45,962.9v-81.51h-617.65v81.51h617.65"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 3398.79,
    y: 990.79,
    width: 617.66,
    height: 139.54
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-82",
    points: "3342.42 798.45 3291.11 798.45 3316.45 798.45 3367.75 798.45 3342.42 798.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "3342.42 1801.2 3291.11 1801.2 3316.45 1798.15 3367.75 1798.15 3342.42 1801.2"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 3342.42,
    y: 798.45,
    width: 25.34,
    height: 999.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 3291.11,
    y: 798.45,
    width: 51.3,
    height: 999.7
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "3342.42 798.45 3291.11 798.45 3391.84 691.25 3443.14 691.25 3342.42 798.45"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-102",
    x: 3423.97,
    y: 1196.55,
    width: 150.25,
    height: 101.75
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 3418.84,
    y: 1196.55,
    width: 5.13,
    height: 101.75
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "3423.97 1196.55 3418.84 1196.55 3569.09 1196.55 3574.22 1196.55 3423.97 1196.55"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-102",
    x: 3423.97,
    y: 1330.7,
    width: 150.25,
    height: 101.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 3418.84,
    y: 1330.7,
    width: 5.13,
    height: 101.74
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "3423.97 1330.7 3418.84 1330.7 3569.09 1330.7 3574.22 1330.7 3423.97 1330.7"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-102",
    x: 3423.97,
    y: 1464.86,
    width: 150.25,
    height: 287.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 3418.84,
    y: 1464.86,
    width: 5.13,
    height: 287.24
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "3423.97 1464.86 3418.84 1464.86 3569.09 1464.86 3574.22 1464.86 3423.97 1464.86"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-102",
    x: 3938.06,
    y: 1197.76,
    width: 94.75,
    height: 560.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 3932.93,
    y: 1197.76,
    width: 5.13,
    height: 560.87
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "3938.06 1197.76 3932.93 1197.76 4027.67 1197.76 4032.8 1197.76 3938.06 1197.76"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 3233.44,
    y: 460.21,
    width: 19.72,
    height: 1342.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 3182.14,
    y: 460.21,
    width: 51.3,
    height: 1342.24
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-70",
    points: "3233.44 460.21 3182.14 460.21 3201.86 460.21 3253.17 460.21 3233.44 460.21"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "3164.8 461.14 3113.5 461.14 3180.36 461.14 3231.66 461.14 3164.8 461.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "3111.84 351.26 3060.54 351.26 3113.5 351.26 3164.8 351.26 3111.84 351.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "3070.23 114.36 3018.93 114.36 3060.54 114.36 3111.84 114.36 3070.23 114.36"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 3018.93,
    y: 114.36,
    width: 51.3,
    height: 236.9
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "2677.93 351.26 2626.62 351.26 3018.93 351.26 3070.23 351.26 2677.93 351.26"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2626.62,
    y: 351.26,
    width: 51.3,
    height: 109.88
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "2575.79 461.14 2524.49 461.14 2626.62 461.14 2677.93 461.14 2575.79 461.14"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2505.06,
    y: 1230.38,
    width: 51.3,
    height: 263.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2398.59,
    y: 1493.45,
    width: 51.3,
    height: 310.07
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "2449.89 1493.45 2398.59 1493.45 2505.06 1493.45 2556.36 1493.45 2449.89 1493.45"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2274.82,
    y: 1136.62,
    width: 51.3,
    height: 93.76
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "2326.12 431.06 2274.82 431.06 2524.49 395.42 2575.79 395.42 2326.12 431.06"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2206.73,
    y: 581.53,
    width: 51.3,
    height: 555.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2206.73,
    y: 506.29,
    width: 51.3,
    height: 75.23
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2206.73,
    y: 461.14,
    width: 51.3,
    height: 45.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2206.73,
    y: 431.06,
    width: 51.3,
    height: 30.08
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "2258.03 297.52 2206.73 297.52 2274.82 297.52 2326.12 297.52 2258.03 297.52"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2206.73,
    y: 297.52,
    width: 51.3,
    height: 133.54
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "3111.84 114.36 3111.84 351.26 3164.8 351.26 3164.8 461.14 3231.66 461.14 3231.66 1802.45 2556.36 1802.45 2449.89 1803.52 2449.89 1493.45 2556.36 1493.45 2556.36 1230.38 2326.12 1230.38 2326.12 1136.62 2258.03 1136.62 2258.03 581.53 2258.03 506.29 2258.03 461.14 2258.03 431.06 2258.03 297.52 2326.12 297.52 2326.12 431.06 2575.79 395.42 2575.79 461.14 2677.93 461.14 2677.93 351.26 3070.23 351.26 3070.23 114.36 3111.84 114.36"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M2331.3,638.36c3.47.22,6.58,1.05,9.31,2.49,2.73,1.44,4.91,3.22,6.54,5.32,1.62,2.11,2.88,4.32,3.77,6.65.89,2.33,1.4,4.68,1.55,7.04.07,2.07-.09,4.05-.5,5.93-.41,1.88-.94,3.46-1.61,4.71-.67,1.26-1.35,2.37-2.05,3.33-.7.96-1.31,1.63-1.83,2l-.78.67c.37.15.89.35,1.55.61.67.26,1.81.94,3.44,2.05,1.62,1.11,3.07,2.42,4.32,3.94,1.26,1.52,2.42,3.68,3.49,6.49,1.07,2.81,1.64,5.91,1.72,9.31.07,3.84-1.02,7.5-3.27,10.98-2.26,3.48-5.23,6.32-8.93,8.54-1.48.81-3.1,1.48-4.88,2-1.77.52-4.08.87-6.93,1.05-2.85.18-5.17.29-6.98.33-1.81.04-4.92.02-9.31-.05-4.4-.08-7.56-.11-9.48-.11l.11-38.58-.11-9.09c4.73-.07,8.91-.11,12.53-.11h2.99c.59,0,1.51-.04,2.77-.11,1.26-.07,2.2-.18,2.83-.33.63-.15,1.46-.37,2.49-.67,1.03-.29,1.81-.67,2.33-1.11.52-.44,1.11-1.02,1.77-1.72.67-.7,1.15-1.51,1.44-2.44.29-.92.54-2,.72-3.21.18-1.22.2-2.61.06-4.16-.22-4.06-1.66-6.87-4.32-8.43-2.66-1.55-6.95-2.25-12.86-2.11l-12.75-.11v-11.42c7.69-.15,14.64-.04,20.84.33ZM2322.76,684.37c0,8.65.04,17.26.11,25.83,8.2.15,14.08-.55,17.63-2.11,2.14-.96,3.88-2.36,5.21-4.21,1.33-1.85,2-3.99,2-6.43,0-5.17-2.11-8.8-6.32-10.87-3.48-1.77-9.42-2.51-17.85-2.22h-.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M2378.31,638.14l12.64-.11-.11,83.49-12.64.11.11-83.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M2430.86,681.82l9.42-9.2c2,.96,3.68,1.81,5.04,2.55,1.37.74,2.97,1.87,4.82,3.38,1.85,1.52,3.33,3.14,4.43,4.88,1.11,1.74,2.03,3.96,2.77,6.65.74,2.7,1.07,5.67,1,8.92-.07,2.07-.44,4.21-1.11,6.43-.67,2.22-1.76,4.42-3.27,6.6-1.52,2.18-3.33,4.1-5.43,5.77s-4.77,2.98-7.98,3.94c-3.22.96-6.75,1.37-10.59,1.22-3.4-.22-6.52-.91-9.37-2.05-2.85-1.15-5.08-2.44-6.71-3.88-1.63-1.44-2.99-2.94-4.1-4.49-1.11-1.55-1.85-2.79-2.22-3.71-.37-.92-.55-1.46-.55-1.61l10.75-11.64c0,.22.02.5.06.83.04.33.13,1,.28,2,.15,1,.35,1.96.61,2.88.26.92.7,1.98,1.33,3.16.63,1.18,1.37,2.22,2.22,3.1.85.89,1.98,1.66,3.38,2.33,1.4.67,2.99,1.11,4.77,1.33,3.47.37,6.76-.48,9.87-2.55,3.1-2.07,4.88-4.8,5.32-8.21.29-2.22.22-4.27-.22-6.15-.44-1.88-1.07-3.4-1.88-4.55-.81-1.14-2.02-2.27-3.6-3.38-1.59-1.11-2.99-1.94-4.21-2.49-1.22-.55-2.83-1.24-4.82-2.05ZM2441.61,650.89c-.15-.22-.39-.48-.72-.78-.33-.29-1.13-.67-2.38-1.11-1.26-.44-2.66-.67-4.21-.67-3.33.07-6.25.92-8.76,2.55-2.51,1.63-3.84,4.21-3.99,7.76-.07,1.7.39,3.23,1.39,4.6,1,1.37,2.09,2.42,3.27,3.16l-8.65,8.76c-6.8-4.29-9.72-10.79-8.76-19.51.59-5.54,3.34-10.14,8.26-13.8,4.92-3.66,10.22-5.52,15.91-5.6,3.25,0,6.43.57,9.54,1.72,3.1,1.15,5.54,2.68,7.32,4.6l-8.2,8.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M2523.99,638.03h12.64v83.6h-12.64v-39.03h-35.92c0,13.01-.04,26.02-.11,39.03h-12.64l.11-50.89h48.56v-32.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M2594.06,636.81c.15-.07.33-.07.55,0,6.73,0,12.84,1.24,18.35,3.71,5.51,2.48,10,5.75,13.47,9.81,3.47,4.07,6.15,8.56,8.04,13.47,1.88,4.92,2.9,10,3.05,15.25.29,7.98-1.42,15.38-5.16,22.17-3.73,6.8-8.96,12.2-15.69,16.19-6.73,3.99-14.16,5.95-22.29,5.88-8.43-.07-15.98-2.07-22.67-5.99-6.69-3.92-11.85-9.09-15.47-15.52-3.62-6.43-5.54-13.53-5.77-21.29-.22-5.25.67-10.44,2.66-15.58,2-5.14,4.82-9.79,8.48-13.97,3.66-4.18,8.32-7.58,13.97-10.2,5.65-2.62,11.81-3.94,18.46-3.94ZM2595.06,648.56v.11c-9.31-.22-16.95,2.74-22.9,8.87-5.95,6.14-8.85,13.71-8.7,22.73.07,8.8,3.1,16.17,9.09,22.12,5.99,5.95,13.12,9,21.4,9.15,3.77.08,7.48-.63,11.14-2.11,3.66-1.48,6.98-3.56,9.98-6.26,2.99-2.7,5.43-6.15,7.32-10.37,1.88-4.21,2.86-8.79,2.94-13.75,0-5.25-1.16-10.12-3.49-14.63-2.33-4.51-5.82-8.22-10.48-11.14-4.66-2.92-10.09-4.49-16.3-4.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M2696.51,646.12c3.77,4.14,5.77,9.24,5.99,15.3.15,5.4-.91,10.09-3.16,14.08-2.26,3.99-5.56,7.1-9.92,9.31-2.07,1.04-5.1,1.85-9.09,2.44-3.99.59-7.95.78-11.86.55h-.22v2.66c-.07,3.84-.11,8.08-.11,12.7v12.69c-.07,1.7-.11,3.1-.11,4.21v1.66l-12.42-.11v-1.55c0-1.18.04-2.59.11-4.21v-12.75c0-4.36.04-10.38.11-18.07-.07-3.03-.11-6.02-.11-8.98,4.88-.07,9.13-.07,12.75,0,2.73.07,5.01.06,6.82-.06,1.81-.11,3.75-.44,5.82-1,2.07-.55,3.71-1.33,4.93-2.33,1.22-1,2.23-2.4,3.05-4.21.81-1.81,1.22-4.05,1.22-6.71,0-2.07-.54-3.97-1.61-5.71-1.07-1.74-2.53-3.08-4.38-4.05-2.81-1.48-8.09-2.25-15.85-2.33l-12.75-.11v-11.53h18.63c9.98.15,17.37,2.85,22.17,8.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M2300.81,836.62l41.36-88.7,39.91,88.7h-13.97l-26.05-60.54-27.61,60.54h-13.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M2446.27,753.03v11.75l-46.12.22v-11.86l46.12-.11ZM2445.38,784.96v11.86h-32.49l-.22,27.94h33.59v11.86l-46.12.11v-51.67l45.24-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M2485.3,753.25c7.54.37,13.64,2.48,18.29,6.32,4.66,3.84,7.13,9.24,7.43,16.19.22,5.32-.46,9.55-2.05,12.7-1.59,3.14-3.94,5.93-7.04,8.37-2.44,1.92-5.47,3.33-9.09,4.21l25.72,35.59-15.52-.11-23.73-34.04c-.81-.07-1.63-.11-2.44-.11.07,11.46.11,22.88.11,34.26h-12.53c0-11.83.04-23.69.11-35.59h-.11v-9.54h12.53c1.85,0,3.38-.02,4.6-.06,1.22-.04,2.7-.18,4.43-.44,1.74-.26,3.2-.59,4.38-1,1.18-.41,2.4-1.01,3.66-1.83,1.26-.81,2.23-1.77,2.94-2.88.7-1.11,1.24-2.53,1.61-4.27.37-1.74.44-3.68.22-5.82-.15-1.7-.85-3.34-2.11-4.93-1.26-1.59-2.81-2.83-4.66-3.71-2.66-1.11-7.69-1.62-15.08-1.55h-12.53v-11.97c7.76-.07,14.71,0,20.84.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M2575.99,751.81c.15-.07.33-.07.55,0,6.73,0,12.84,1.24,18.35,3.71,5.51,2.48,10,5.75,13.47,9.81,3.47,4.07,6.15,8.56,8.04,13.47,1.88,4.92,2.9,10,3.05,15.25.29,7.98-1.42,15.38-5.16,22.17-3.73,6.8-8.96,12.2-15.69,16.19-6.73,3.99-14.16,5.95-22.29,5.88-8.43-.07-15.98-2.07-22.67-5.99-6.69-3.92-11.85-9.09-15.47-15.52-3.62-6.43-5.54-13.53-5.77-21.29-.22-5.25.67-10.44,2.66-15.58,2-5.14,4.82-9.79,8.48-13.97,3.66-4.18,8.32-7.58,13.97-10.2,5.65-2.62,11.81-3.94,18.46-3.94ZM2576.99,763.56v.11c-9.31-.22-16.95,2.74-22.9,8.87-5.95,6.14-8.85,13.71-8.7,22.73.07,8.8,3.1,16.17,9.09,22.12,5.99,5.95,13.12,9,21.4,9.15,3.77.08,7.48-.63,11.14-2.11,3.66-1.48,6.98-3.56,9.98-6.26,2.99-2.7,5.43-6.15,7.32-10.37,1.88-4.21,2.86-8.79,2.94-13.75,0-5.25-1.16-10.12-3.49-14.63-2.33-4.51-5.82-8.22-10.48-11.14-4.66-2.92-10.09-4.49-16.3-4.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M2637.08,836.62l.44-53.11,12.64,12.86v40.25h-13.08ZM2637.3,767l.11-20.18,74.28,76.17.22,20.29-74.62-76.28ZM2711.92,807.24l-13.42-14.3.55-40.03,12.64.22.22,54.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M2720.46,836.62l41.36-88.7,39.91,88.7h-13.97l-26.05-60.54-27.61,60.54h-13.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M2810.93,753.03l12.64.11c.07,23.95.11,42.06.11,54.33,0,5.4,1.68,9.92,5.04,13.58,3.36,3.66,7.71,5.49,13.03,5.49s9.7-1.81,13.14-5.43c3.44-3.62,5.19-8.28,5.27-13.97.07-9.16.11-27.2.11-54.11h12.53c.07,22.47.07,40.88,0,55.21,0,5.91-1.5,11.18-4.49,15.8-2.99,4.62-6.86,8.11-11.59,10.48-4.73,2.36-9.87,3.55-15.41,3.55-5.1,0-9.92-1.16-14.47-3.49-4.55-2.33-8.32-5.84-11.31-10.53-2.99-4.69-4.49-10.03-4.49-16.02-.07-4.51-.11-22.84-.11-54.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M2882.11,764.89v-11.75l51-.11v11.86h-19.18v71.73h-12.64l.11-71.73h-19.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M2951.29,753.14l12.64-.11-.11,83.49-12.64.11.11-83.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M3043.87,816.78l-.22,15.3c-.22.15-.61.37-1.16.67-.55.3-1.68.81-3.38,1.55-1.7.74-3.44,1.39-5.21,1.94-1.77.55-4.03,1.03-6.76,1.44-2.74.41-5.47.57-8.2.5-3.84-.15-7.71-.85-11.59-2.11-3.88-1.26-7.59-3.14-11.14-5.65-3.55-2.51-6.67-5.43-9.37-8.76-2.7-3.33-4.84-7.3-6.43-11.92-1.59-4.62-2.35-9.55-2.27-14.8.07-6.36,1.33-12.31,3.77-17.85,2.44-5.54,5.62-10.15,9.54-13.8,3.92-3.66,8.35-6.54,13.3-8.65,4.95-2.11,9.98-3.2,15.08-3.27,4.14,0,8.22.5,12.25,1.5,4.03,1,6.97,2.01,8.81,3.05l2.88,1.55v15.08c-.22-.22-.54-.54-.94-.94-.41-.41-1.35-1.15-2.83-2.22-1.48-1.07-3.07-2-4.77-2.77-1.7-.78-3.94-1.5-6.71-2.16-2.77-.67-5.64-1.03-8.59-1.11-3.55,0-7.08.78-10.59,2.33-3.51,1.55-6.64,3.68-9.37,6.38-2.74,2.7-4.97,5.99-6.71,9.87-1.74,3.88-2.68,7.97-2.83,12.25-.15,4.36.61,8.56,2.27,12.58,1.66,4.03,3.88,7.47,6.65,10.31,2.77,2.85,5.95,5.12,9.54,6.82,3.58,1.7,7.19,2.59,10.81,2.66,2.73,0,5.45-.31,8.15-.94,2.7-.63,4.97-1.42,6.82-2.38,1.85-.96,3.49-1.94,4.93-2.94s2.49-1.83,3.16-2.5l1.11-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M3083.78,796.82l9.42-9.2c2,.96,3.68,1.81,5.04,2.55,1.37.74,2.97,1.87,4.82,3.38,1.85,1.52,3.33,3.14,4.43,4.88,1.11,1.74,2.03,3.96,2.77,6.65.74,2.7,1.07,5.67,1,8.92-.07,2.07-.44,4.21-1.11,6.43-.67,2.22-1.76,4.42-3.27,6.6-1.52,2.18-3.33,4.1-5.43,5.77s-4.77,2.98-7.98,3.94c-3.22.96-6.75,1.37-10.59,1.22-3.4-.22-6.52-.91-9.37-2.05-2.85-1.15-5.08-2.44-6.71-3.88-1.63-1.44-2.99-2.94-4.1-4.49-1.11-1.55-1.85-2.79-2.22-3.71-.37-.92-.55-1.46-.55-1.61l10.75-11.64c0,.22.02.5.06.83.04.33.13,1,.28,2,.15,1,.35,1.96.61,2.88.26.92.7,1.98,1.33,3.16.63,1.18,1.37,2.22,2.22,3.1.85.89,1.98,1.66,3.38,2.33,1.4.67,2.99,1.11,4.77,1.33,3.47.37,6.76-.48,9.87-2.55,3.1-2.07,4.88-4.8,5.32-8.21.29-2.22.22-4.27-.22-6.15-.44-1.88-1.07-3.4-1.88-4.55-.81-1.14-2.02-2.27-3.6-3.38-1.59-1.11-2.99-1.94-4.21-2.49-1.22-.55-2.83-1.24-4.82-2.05ZM3094.54,765.89c-.15-.22-.39-.48-.72-.78-.33-.29-1.13-.67-2.38-1.11-1.26-.44-2.66-.67-4.21-.67-3.33.07-6.25.92-8.76,2.55-2.51,1.63-3.84,4.21-3.99,7.76-.07,1.7.39,3.23,1.39,4.6,1,1.37,2.09,2.42,3.27,3.16l-8.65,8.76c-6.8-4.29-9.72-10.79-8.76-19.51.59-5.54,3.34-10.14,8.26-13.8,4.92-3.66,10.22-5.52,15.91-5.6,3.25,0,6.43.57,9.54,1.72,3.1,1.15,5.54,2.68,7.32,4.6l-8.2,8.32Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 3069.74,
    y: 98.59,
    width: 41.61,
    height: 35.68
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 3018.44,
    y: 98.59,
    width: 51.3,
    height: 35.68
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-70",
    points: "3069.74 98.59 3018.44 98.59 3060.05 98.59 3111.35 98.59 3069.74 98.59"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 2325.29,
    y: 1212.38,
    width: 231.1,
    height: 20.98
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 2273.98,
    y: 1212.38,
    width: 51.3,
    height: 20.98
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-70",
    points: "2325.29 1212.38 2273.98 1212.38 2505.09 1212.38 2556.39 1212.38 2325.29 1212.38"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 2258.89,
    y: 1112.75,
    width: 556.07,
    height: 20.98
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 2207.59,
    y: 1112.75,
    width: 51.3,
    height: 20.98
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-70",
    points: "2258.89 1112.75 2207.59 1112.75 2763.66 1112.75 2814.96 1112.75 2258.89 1112.75"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 2439.69,
    y: 1493.45,
    width: 19.71,
    height: 310.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 2388.39,
    y: 1493.45,
    width: 51.3,
    height: 310.07
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-70",
    points: "2439.69 1493.45 2388.39 1493.45 2408.1 1493.45 2459.4 1493.45 2439.69 1493.45"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 2260.91,
    y: 201.82,
    width: 63.82,
    height: 95.71
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 2209.61,
    y: 201.82,
    width: 51.3,
    height: 95.71
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-70",
    points: "2260.91 201.82 2209.61 201.82 2273.43 201.82 2324.73 201.82 2260.91 201.82"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2102.09,
    y: 1420.48,
    width: 51.3,
    height: 76.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2102.09,
    y: 1264.32,
    width: 51.3,
    height: 74.65
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "2036.18 578.17 1984.87 578.17 1975.4 503.54 2026.7 503.54 2036.18 578.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "2016.35 422.02 1965.05 422.02 1955.32 345.43 2006.62 345.43 2016.35 422.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "1830.38 1497.07 1779.08 1497.07 2102.09 1497.07 2153.4 1497.07 1830.38 1497.07"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-85",
    x: 1779.09,
    y: 1420.48,
    width: 51.3,
    height: 76.6
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-92",
    points: "1830.39 1420.48 1779.09 1420.48 2102.1 1420.48 2153.4 1420.48 1830.39 1420.48"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 1830.39,
    y: 1420.48,
    width: 323.02,
    height: 76.6
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "1830.38 1338.96 1779.08 1338.96 2102.09 1338.96 2153.4 1338.96 1830.38 1338.96"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 1830.39,
    y: 1264.33,
    width: 323.02,
    height: 74.64
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-92",
    points: "1830.39 1264.33 1779.09 1264.33 2102.1 1264.33 2153.4 1264.33 1830.39 1264.33"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-85",
    x: 1779.09,
    y: 1264.33,
    width: 51.3,
    height: 74.64
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-95",
    points: "1784.72 126.04 1733.42 126.04 1734.4 123.75 1785.7 123.75 1784.72 126.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-95",
    points: "1784.14 127.39 1732.84 127.39 1733.42 126.04 1784.72 126.04 1784.14 127.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "2022.68 243.26 1971.37 243.26 1732.84 127.39 1784.14 127.39 2022.68 243.26"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1732.67,
    y: 1060.3,
    width: 51.3,
    height: 740.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1732.67,
    y: 825.65,
    width: 51.3,
    height: 184.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1732.67,
    y: 649.48,
    width: 51.3,
    height: 124.04
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-92",
    points: "1780.15 503.54 1728.85 503.54 1975.4 503.54 2026.71 503.54 1780.15 503.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "1780.14 578.17 1728.84 578.17 1984.87 578.17 2036.18 578.17 1780.14 578.17"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-85",
    x: 1728.85,
    y: 503.54,
    width: 51.3,
    height: 74.64
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-92",
    points: "1780.15 345.43 1728.85 345.43 1955.33 345.43 2006.63 345.43 1780.15 345.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "1780.14 422.02 1728.84 422.02 1965.05 422.02 2016.35 422.02 1780.14 422.02"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-85",
    x: 1728.85,
    y: 345.43,
    width: 51.3,
    height: 76.6
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "1765.78 825.65 1714.47 825.65 1732.67 825.65 1783.98 825.65 1765.78 825.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "1765.77 1010.27 1714.47 1010.27 1732.67 1010.27 1783.97 1010.27 1765.77 1010.27"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-90",
    x: 1765.78,
    y: 825.65,
    width: 18.2,
    height: 184.63
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-100",
    x: 1714.47,
    y: 825.65,
    width: 51.3,
    height: 184.63
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1697.52,
    y: 825.65,
    width: 51.3,
    height: 184.62
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "1730.64 825.65 1679.33 825.65 1697.53 825.65 1748.84 825.65 1730.64 825.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "1730.63 1010.27 1679.32 1010.27 1697.52 1010.27 1748.83 1010.27 1730.63 1010.27"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-100",
    x: 1679.33,
    y: 825.65,
    width: 51.3,
    height: 184.63
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1662.39,
    y: 825.65,
    width: 51.3,
    height: 184.62
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "1695.5 825.65 1644.19 825.65 1662.39 825.65 1713.7 825.65 1695.5 825.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "1695.49 1010.27 1644.19 1010.27 1662.39 1010.27 1713.69 1010.27 1695.49 1010.27"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-100",
    x: 1644.19,
    y: 825.65,
    width: 51.3,
    height: 184.63
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-90",
    x: 1695.5,
    y: 825.65,
    width: 18.2,
    height: 184.63
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1627.25,
    y: 825.65,
    width: 51.3,
    height: 184.62
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "1660.34 1010.27 1609.04 1010.27 1627.25 1010.27 1678.55 1010.27 1660.34 1010.27"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-100",
    x: 1609.05,
    y: 825.65,
    width: 51.3,
    height: 184.63
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "1660.36 825.65 1609.05 825.65 1627.25 825.65 1678.56 825.65 1660.36 825.65"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1592.1,
    y: 825.65,
    width: 51.3,
    height: 184.62
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "1625.21 1010.27 1573.91 1010.27 1592.1 1010.27 1643.41 1010.27 1625.21 1010.27"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-90",
    x: 1625.22,
    y: 825.65,
    width: 18.2,
    height: 184.63
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-100",
    x: 1573.91,
    y: 825.65,
    width: 51.3,
    height: 184.63
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "1625.22 825.65 1573.91 825.65 1592.11 825.65 1643.42 825.65 1625.22 825.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "1625.21 773.51 1573.91 773.51 1732.67 773.51 1783.97 773.51 1625.21 773.51"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1542.94,
    y: 1062.38,
    width: 51.3,
    height: 702.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1542.58,
    y: 21.39,
    width: 51.3,
    height: 621.98
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "1564.65 1764.78 1513.34 1764.78 1542.94 1764.78 1594.25 1764.78 1564.65 1764.78"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 1513.34,
    y: 1062.39,
    width: 51.3,
    height: 702.4
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-82",
    points: "1564.65 1062.39 1513.34 1062.39 1542.94 1062.39 1594.25 1062.39 1564.65 1062.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "1558.3 643.37 1506.99 643.37 1542.58 643.37 1593.88 643.37 1558.3 643.37"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 1507,
    y: 90.9,
    width: 51.3,
    height: 552.47
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-94",
    points: "1558.3 90.9 1507 90.9 1542.58 21.4 1593.88 21.4 1558.3 90.9"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1484.29,
    y: 122,
    width: 51.3,
    height: 522.17
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "1500.02 644.17 1448.72 644.17 1484.29 644.17 1535.6 644.17 1500.02 644.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1535.6 122 1535.6 644.17 1500.03 644.17 1500.03 191.51 1535.6 122"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 1448.73,
    y: 191.51,
    width: 51.3,
    height: 452.66
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-94",
    points: "1500.03 191.51 1448.73 191.51 1484.3 122 1535.6 122 1500.03 191.51"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1428.07,
    y: 228.22,
    width: 51.3,
    height: 417.02
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "1443.8 645.24 1392.5 645.24 1428.07 645.24 1479.37 645.24 1443.8 645.24"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 1392.5,
    y: 294.16,
    width: 51.3,
    height: 351.08
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-94",
    points: "1443.8 294.16 1392.5 294.16 1428.08 228.22 1479.38 228.22 1443.8 294.16"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1358.29,
    y: 295.16,
    width: 51.3,
    height: 477.51
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1256.35,
    y: 1062.38,
    width: 51.3,
    height: 702.4
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "1278.05 1764.78 1226.75 1764.78 1256.35 1764.78 1307.65 1764.78 1278.05 1764.78"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 1226.74,
    y: 1062.39,
    width: 51.3,
    height: 702.4
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-82",
    points: "1278.05 1062.39 1226.74 1062.39 1256.34 1062.39 1307.65 1062.39 1278.05 1062.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M2202.32,1313.52l.38,213.85-83.74,168.94-.37,104.05h-334.62s0-740.06,0-740.06h-158.76v740.06h-382.99s0-778.84,0-778.84l86.1-127.27v-123.5l81.28,1.91v-477.51l215.61-401.16v879.51h158.76v-124.04h-51.71s0-352.96,0-352.96l51.71-53.46v-117.38l238.64,117.73,80.65,555.37,99.06,222.76v292ZM2153.4,1497.07v-76.6h-323.01v76.6h323.01M2153.4,1338.96v-74.65h-323.01v74.65h323.01M1558.3,90.89v552.48h35.58V21.39l-35.58,69.5M1594.25,1764.78v-702.4h-29.6v702.4h29.6M1307.65,1764.78v-702.4h-29.6v702.4h29.6M1780.14,578.17h256.03s-9.48-74.63-9.48-74.63h-246.55v74.63M1535.6,644.17V122l-35.57,69.5v452.67h35.57M1780.14,345.43v76.6h236.21s-9.73-76.6-9.73-76.6h-226.48M1479.37,645.24V228.22l-35.57,65.94v351.09h35.57M1678.55,1010.27v-184.62h-18.21v184.62h18.21M1713.69,1010.27v-184.62h-18.2v184.62h18.2M1748.83,1010.27v-184.62h-18.2v184.62h18.2M1643.41,1010.27v-184.62h-18.2v184.62h18.2M1783.97,1010.27v-184.62h-18.2v184.62h18.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-84",
    points: "1785.7 123.75 2024.18 239.77 2022.68 243.26 1784.14 127.39 1784.72 126.04 1785.7 123.75"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1732.67,
    y: 125.67,
    width: 51.3,
    height: 117.38
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "2026.71 503.54 2036.18 578.18 1780.15 578.18 1780.15 503.54 2026.71 503.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "2006.63 345.43 2016.35 422.03 1780.15 422.03 1780.15 345.43 2006.63 345.43"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1680.96,
    y: 296.51,
    width: 51.3,
    height: 352.96
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "1732.27 296.51 1680.96 296.51 1732.67 243.05 1783.97 243.05 1732.27 296.51"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-90",
    x: 1730.64,
    y: 825.65,
    width: 18.2,
    height: 184.63
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-90",
    x: 1660.36,
    y: 825.65,
    width: 18.2,
    height: 184.63
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1564.65,
    y: 1062.39,
    width: 29.6,
    height: 702.4
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1593.88 21.4 1593.88 643.37 1558.3 643.37 1558.3 90.9 1593.88 21.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1479.38 228.22 1479.38 645.25 1443.8 645.25 1443.8 294.16 1479.38 228.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "1409.6 295.16 1358.29 295.16 1573.91 -106 1625.21 -106 1409.6 295.16"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1277.01,
    y: 770.76,
    width: 51.3,
    height: 123.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1278.05,
    y: 1062.39,
    width: 29.6,
    height: 702.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1190.91,
    y: 1021.52,
    width: 51.3,
    height: 778.84
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "1242.22 1021.52 1190.91 1021.52 1277.01 894.26 1328.31 894.26 1242.22 1021.52"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 1095.98,
    y: 372.93,
    width: 51.3,
    height: 1430.59
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1063.16,
    y: 1527.5,
    width: 51.3,
    height: 14.26
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1063.16,
    y: 1479.19,
    width: 51.3,
    height: 14.26
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1063.16,
    y: 1430.88,
    width: 51.3,
    height: 14.26
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1063.16,
    y: 1382.58,
    width: 51.3,
    height: 14.26
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1063.16,
    y: 1334.27,
    width: 51.3,
    height: 14.26
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M1147.29,372.93h-51.3c0-68.28-24.99-132.48-70.36-180.76-45.37-48.29-105.7-74.88-169.86-74.88h51.3c64.16,0,124.49,26.6,169.86,74.88,45.37,48.28,70.36,112.48,70.36,180.76"
  })))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1049.56,
    y: 350.19,
    width: 51.3,
    height: 460.53
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "1090.81 810.72 1039.51 810.72 1049.56 810.72 1100.86 810.72 1090.81 810.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "1090.81 350.19 1039.51 350.19 1049.55 350.19 1100.86 350.19 1090.81 350.19"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 1039.51,
    y: 350.19,
    width: 51.3,
    height: 460.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-96",
    x: 1090.81,
    y: 350.19,
    width: 10.05,
    height: 460.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 999.52,
    y: 350.19,
    width: 51.3,
    height: 460.53
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "1040.78 810.72 989.47 810.72 999.52 810.72 1050.83 810.72 1040.78 810.72"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 989.47,
    y: 350.19,
    width: 51.3,
    height: 460.53
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "1040.78 350.19 989.47 350.19 999.52 350.19 1050.82 350.19 1040.78 350.19"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 949.49,
    y: 350.19,
    width: 51.3,
    height: 460.53
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "990.75 810.72 939.44 810.72 949.49 810.72 1000.79 810.72 990.75 810.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "990.74 350.19 939.44 350.19 949.49 350.19 1000.79 350.19 990.74 350.19"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 939.44,
    y: 350.19,
    width: 51.3,
    height: 460.53
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "987.18 1541.75 935.88 1541.75 1063.16 1541.75 1114.46 1541.75 987.18 1541.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "987.18 1493.45 935.88 1493.45 1063.16 1493.45 1114.46 1493.45 987.18 1493.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "987.18 1445.14 935.88 1445.14 1063.16 1445.14 1114.46 1445.14 987.18 1445.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "987.18 1396.84 935.88 1396.84 1063.16 1396.84 1114.46 1396.84 987.18 1396.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "987.18 1348.52 935.88 1348.52 1063.16 1348.52 1114.46 1348.52 987.18 1348.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "987.18 1527.5 935.88 1527.5 1063.15 1527.5 1114.46 1527.5 987.18 1527.5"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 935.88,
    y: 1527.5,
    width: 51.3,
    height: 14.26
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-96",
    x: 987.18,
    y: 1527.5,
    width: 127.27,
    height: 14.26
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 935.88,
    y: 1479.19,
    width: 51.3,
    height: 14.26
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "987.18 1479.19 935.88 1479.19 1063.15 1479.19 1114.46 1479.19 987.18 1479.19"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-96",
    x: 987.18,
    y: 1430.88,
    width: 127.27,
    height: 14.26
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "987.18 1430.88 935.88 1430.88 1063.15 1430.88 1114.46 1430.88 987.18 1430.88"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 935.88,
    y: 1430.88,
    width: 51.3,
    height: 14.26
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "987.18 1382.58 935.88 1382.58 1063.15 1382.58 1114.46 1382.58 987.18 1382.58"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 935.88,
    y: 1382.58,
    width: 51.3,
    height: 14.26
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-96",
    x: 987.18,
    y: 1334.27,
    width: 127.27,
    height: 14.26
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 935.88,
    y: 1334.27,
    width: 51.3,
    height: 14.26
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "987.18 1334.27 935.88 1334.27 1063.15 1334.27 1114.46 1334.27 987.18 1334.27"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 901.15,
    y: 348.79,
    width: 51.3,
    height: 458.91
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 855.76,
    y: 113.29,
    width: 51.3,
    height: 4
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1076.92,192.17c45.37,48.28,70.36,112.48,70.36,180.76v1430.59h-240.24s0-995.82,0-995.82h45.4v-458.91h-45.4s0-235.49,0-235.49v3.99c64.18,0,124.5,26.6,169.87,74.88ZM1090.81,350.19v460.53h10.05v-460.53h-10.05M1040.78,350.19v460.53h10.05v-460.53h-10.05M990.75,350.19v460.53h10.04v-460.53h-10.04M1114.46,1493.45v-14.26h-127.27v14.26h127.27M1114.46,1541.75v-14.26h-127.27v14.26h127.27M1114.46,1445.14v-14.26h-127.27v14.26h127.27M1114.46,1396.84v-14.26h-127.27v14.26h127.27M1114.46,1348.52v-14.26h-127.27v14.26h127.27"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-96",
    x: 1040.78,
    y: 350.19,
    width: 10.05,
    height: 460.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-96",
    x: 990.74,
    y: 350.19,
    width: 10.05,
    height: 460.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-96",
    x: 987.18,
    y: 1479.19,
    width: 127.27,
    height: 14.26
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-96",
    x: 987.18,
    y: 1382.58,
    width: 127.27,
    height: 14.26
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M907.06,109.29c66.17,0,128.39,27.42,175.18,77.22s72.56,116.01,72.56,186.43v1430.59h-3.76s-3.76,0-3.76,0V372.93c0-68.28-24.99-132.48-70.36-180.76-45.37-48.29-105.7-74.88-169.86-74.88v-8Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 855.76,
    y: 109.29,
    width: 51.3,
    height: 4.01
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "907.05 807.7 855.75 807.7 901.15 807.7 952.45 807.7 907.05 807.7"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 855.75,
    y: 807.7,
    width: 51.3,
    height: 995.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 855.75,
    y: 113.29,
    width: 51.3,
    height: 235.49
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-102",
    x: 935.24,
    y: 860.46,
    width: 150.26,
    height: 71.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 930.11,
    y: 860.46,
    width: 5.13,
    height: 71.62
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "935.24 860.46 930.11 860.46 1080.37 860.46 1085.5 860.46 935.24 860.46"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-102",
    x: 935.24,
    y: 973.47,
    width: 150.26,
    height: 71.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 930.11,
    y: 973.47,
    width: 5.13,
    height: 71.62
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "935.24 973.47 930.11 973.47 1080.37 973.47 1085.5 973.47 935.24 973.47"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-102",
    x: 935.24,
    y: 1086.46,
    width: 150.26,
    height: 71.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 930.11,
    y: 1086.46,
    width: 5.13,
    height: 71.62
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "935.24 1086.46 930.11 1086.46 1080.37 1086.46 1085.5 1086.46 935.24 1086.46"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-102",
    x: 935.24,
    y: 1195.55,
    width: 150.26,
    height: 71.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 930.11,
    y: 1195.55,
    width: 5.13,
    height: 71.62
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "935.24 1195.55 930.11 1195.55 1080.37 1195.55 1085.5 1195.55 935.24 1195.55"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-102",
    x: 2629.21,
    y: 1205.28,
    width: 104.58,
    height: 547.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 2624.08,
    y: 1205.28,
    width: 5.13,
    height: 547.82
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "2629.21 1205.28 2624.08 1205.28 2728.67 1205.28 2733.8 1205.28 2629.21 1205.28"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-102",
    x: 2787.86,
    y: 1302.65,
    width: 104.58,
    height: 450.45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 2782.73,
    y: 1302.65,
    width: 5.13,
    height: 450.45
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "2787.86 1302.65 2782.73 1302.65 2887.31 1302.65 2892.44 1302.65 2787.86 1302.65"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-102",
    x: 2946.51,
    y: 1302.65,
    width: 104.58,
    height: 450.45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 2941.38,
    y: 1302.65,
    width: 5.13,
    height: 450.45
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "2946.51 1302.65 2941.38 1302.65 3045.96 1302.65 3051.09 1302.65 2946.51 1302.65"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-102",
    x: 3105.15,
    y: 1205.28,
    width: 104.58,
    height: 547.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 3100.02,
    y: 1205.28,
    width: 5.13,
    height: 547.82
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "3105.15 1205.28 3100.02 1205.28 3204.6 1205.28 3209.73 1205.28 3105.15 1205.28"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-102",
    points: "2053.52 687.26 2087.01 1149.03 1892.68 1149.03 1892.68 687.26 2053.52 687.26"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 1887.55,
    y: 687.26,
    width: 5.13,
    height: 461.77
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "1892.68 687.26 1887.55 687.26 2048.39 687.26 2053.52 687.26 1892.68 687.26"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-102",
    points: "1577.98 889.03 1577.98 1024.51 1541.6 1024.51 1541.6 1496.07 1435.74 1496.07 1435.74 889.03 1577.98 889.03"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 1430.61,
    y: 889.03,
    width: 5.13,
    height: 607.04
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "1435.74 889.03 1430.61 889.03 1572.85 889.03 1577.98 889.03 1435.74 889.03"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "5506.07 1566.97 5454.77 1566.97 5494.99 1566.97 5546.3 1566.97 5506.07 1566.97"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 5350.29,
    y: 1566.97,
    width: 51.3,
    height: 68.35
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "5401.6 1530.39 5350.29 1530.39 5454.77 1530.39 5506.07 1530.39 5401.6 1530.39"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 5350.29,
    y: 1530.39,
    width: 51.3,
    height: 36.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-96",
    x: 5344.63,
    y: 647.68,
    width: 10.05,
    height: 444.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 5293.33,
    y: 647.68,
    width: 51.3,
    height: 444.41
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "5344.63 647.68 5293.33 647.68 5303.37 647.68 5354.68 647.68 5344.63 647.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "5310.7 651.01 5259.39 651.01 5293.32 651.01 5344.62 651.01 5310.7 651.01"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 5137.46,
    y: 1313.34,
    width: 51.3,
    height: 205.1
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "4936.15 884.41 4884.84 884.41 4882.76 882.39 4934.07 882.39 4936.15 884.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "4934.06 885.38 4882.75 885.38 4884.16 883.75 4935.46 883.75 4934.06 885.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-86",
    points: "4931.98 880.36 4880.68 880.36 5257.32 442.57 5308.63 442.57 4931.98 880.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "4755.06 879.38 4703.76 879.38 4881.53 879.38 4932.83 879.38 4755.06 879.38"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 4702.52,
    y: 882.39,
    width: 51.3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 4702.52,
    y: 879.38,
    width: 51.3,
    height: 3.01
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "4753.82 879.38 4702.52 879.38 4703.76 879.38 4755.06 879.38 4753.82 879.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "4934.07 882.39 4882.76 882.39 4880.68 880.36 4931.98 880.36 4934.07 882.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-96",
    points: "4932.83 879.38 4931.98 880.36 4934.07 882.39 4934.07 885.38 4753.82 885.38 4753.82 882.39 4753.82 879.38 4755.06 879.38 4932.83 879.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "4499.11 1518.44 4447.81 1518.44 5137.46 1518.44 5188.76 1518.44 4499.11 1518.44"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 4447.82,
    y: 1313.34,
    width: 51.3,
    height: 205.1
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "4499.12 1313.34 4447.82 1313.34 5137.47 1313.34 5188.77 1313.34 4499.12 1313.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "4751.74 884.41 4700.44 884.41 4325.88 449.04 4377.18 449.04 4751.74 884.41"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 4325.87,
    y: 1092.09,
    width: 51.3,
    height: 437.58
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "4286.26 1635.33 4234.96 1635.33 4325.87 1529.67 4377.18 1529.67 4286.26 1635.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "4141.58 1803.51 4090.27 1803.51 4094.58 1798.49 4145.88 1798.49 4141.58 1803.51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M5546.3,1566.97v231.52h-4.31s4.31,5.01,4.31,5.01h-235.6s-933.52,0-933.52,0h-235.6s4.31-5.01,4.31-5.01h-4.31s0-231.52,0-231.52h40.22v-36.58h104.47s0,36.58,0,36.58v68.35l90.91-105.66v-437.58h-39.73s0-441.08,0-441.08h39.73v-201.97l374.56,435.37,182.32.97,376.64-436.34v201.97h33.92s0,441.08,0,441.08h-33.92v437.58l90.9,105.66v-104.94h104.47s0,36.58,0,36.58h40.23ZM5188.76,1518.44v-205.1h-689.65v205.1h689.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "5303.07 449.04 4931.98 880.36 4934.06 882.39 4935.46 883.75 4935.46 883.75 5310.69 449.04 5303.07 449.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-96",
    points: "5308.63 442.57 5312.78 446.62 5310.7 449.04 4936.15 884.41 4934.07 882.39 4931.98 880.36 5308.63 442.57"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-96",
    x: 4499.12,
    y: 1313.34,
    width: 689.65,
    height: 205.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 4325.87,
    y: 449.04,
    width: 51.3,
    height: 201.97
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-96",
    points: "4379.26 442.57 4755.06 879.38 4753.82 882.39 4751.74 884.41 4377.18 449.04 4375.1 446.63 4379.26 442.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "4377.18 449.04 4325.88 449.04 4323.8 446.63 4375.1 446.63 4377.18 449.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "4375.1 446.63 4323.8 446.63 4327.96 442.57 4379.26 442.57 4375.1 446.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "4337.45 651.01 4286.14 651.01 4325.87 651.01 4377.18 651.01 4337.45 651.01"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 4286.14,
    y: 651.01,
    width: 51.3,
    height: 441.08
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-96",
    x: 4326.76,
    y: 647.69,
    width: 10.06,
    height: 444.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 4275.46,
    y: 647.69,
    width: 51.3,
    height: 444.41
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "4326.76 647.69 4275.46 647.68 4285.51 647.68 4336.82 647.69 4326.76 647.69"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 4130.49,
    y: 1530.39,
    width: 51.3,
    height: 36.58
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "4181.79 1530.39 4130.49 1530.39 4234.96 1530.39 4286.26 1530.39 4181.79 1530.39"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 4090.27,
    y: 1566.97,
    width: 51.3,
    height: 231.52
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "4141.58 1566.97 4090.27 1566.97 4130.49 1566.97 4181.79 1566.97 4141.58 1566.97"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-102",
    x: 4521.1,
    y: 1575.58,
    width: 694.53,
    height: 95.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 4515.97,
    y: 1575.58,
    width: 5.13,
    height: 95.03
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "4521.1 1575.58 4515.97 1575.58 5210.5 1575.58 5215.63 1575.58 4521.1 1575.58"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-102",
    x: 4529.82,
    y: 999.55,
    width: 133.37,
    height: 248.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 4524.69,
    y: 999.55,
    width: 5.13,
    height: 248.88
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "4529.82 999.55 4524.69 999.55 4658.06 999.55 4663.19 999.55 4529.82 999.55"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-83",
    x: 5073.01,
    y: 999.55,
    width: 133.37,
    height: 248.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    x: 5067.88,
    y: 999.55,
    width: 5.13,
    height: 248.88
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-99",
    points: "5073.01 999.55 5067.88 999.55 5201.25 999.55 5206.38 999.55 5073.01 999.55"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-102",
    x: 4771.22,
    y: 966.7,
    width: 200.36,
    height: 284.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 4766.09,
    y: 966.7,
    width: 5.13,
    height: 284.53
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "4771.22 966.7 4766.09 966.7 4966.45 966.7 4971.58 966.7 4771.22 966.7"
  })))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 694.86,
    y: 1331.25,
    width: 51.3,
    height: 10.95
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-47"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M739.58,1349.2h-51.3c3.63,0,6.58-3.14,6.58-7h51.3c0,3.86-2.94,7-6.58,7"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M746.16,1331.25h-51.3c0-3.86-2.94-7.01-6.58-7.01h51.3c3.63,0,6.58,3.15,6.58,7.01"
  })))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 678.11,
    y: 1227.71,
    width: 51.3,
    height: 10.95
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-49"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M722.84,1245.66h-51.3c3.63,0,6.58-3.13,6.58-7h51.3c0,3.87-2.94,7-6.58,7"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-45"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M729.42,1227.71h-51.3c0-3.86-2.94-6.99-6.58-6.99h51.3c3.63,0,6.58,3.13,6.58,6.99"
  })))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 661.37,
    y: 1124.17,
    width: 51.3,
    height: 10.94
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-66"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M706.09,1142.11h-51.3c3.63,0,6.58-3.13,6.58-7h51.3c0,3.87-2.94,7-6.58,7"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-60"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M712.67,1124.17h-51.3c0-3.87-2.94-7-6.58-7h51.3c3.63,0,6.58,3.13,6.58,7"
  })))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 644.63,
    y: 1020.62,
    width: 51.3,
    height: 10.94
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-61"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M689.34,1038.57h-51.3c3.63,0,6.58-3.13,6.58-7h51.3c0,3.87-2.96,7-6.58,7"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-62"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M689.34,1038.57h-51.3c3.63,0,6.58-3.13,6.58-7h51.3c0,3.87-2.96,7-6.58,7"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-63"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M695.93,1020.62h-51.3c0-3.87-2.96-7-6.58-7h51.3c3.63,0,6.58,3.13,6.58,7"
  })))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 627.87,
    y: 917.08,
    width: 51.3,
    height: 10.96
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-64"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M672.6,935.02h-51.3c3.63,0,6.58-3.13,6.58-6.99h51.3c0,3.86-2.95,6.99-6.58,6.99"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-67"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M679.18,917.08h-51.3c0-3.87-2.95-7-6.58-7h51.3c3.63,0,6.58,3.13,6.58,7"
  })))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 611.12,
    y: 813.53,
    width: 51.3,
    height: 10.96
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-68"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M655.86,831.49h-51.3c3.63,0,6.57-3.14,6.57-7h51.3c0,3.86-2.94,7-6.57,7"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-69"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M662.43,813.53h-51.3c0-3.86-2.94-7-6.57-7h51.3c3.63,0,6.57,3.14,6.57,7"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "441.25 1349.2 389.95 1349.2 688.28 1349.2 739.58 1349.2 441.25 1349.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "441.25 1245.66 389.95 1245.66 671.53 1245.66 722.84 1245.66 441.25 1245.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "441.25 1142.11 389.95 1142.11 654.79 1142.11 706.09 1142.11 441.25 1142.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "441.25 1038.57 389.95 1038.57 638.04 1038.57 689.34 1038.57 441.25 1038.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "441.25 935.02 389.95 935.02 621.3 935.02 672.6 935.02 441.25 935.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "441.25 831.49 389.95 831.49 604.55 831.49 655.86 831.49 441.25 831.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-82",
    points: "441.25 1324.25 389.95 1324.25 688.28 1324.25 739.58 1324.25 441.25 1324.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-82",
    points: "441.25 1220.71 389.95 1220.71 671.53 1220.71 722.83 1220.71 441.25 1220.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-82",
    points: "441.25 1117.17 389.95 1117.17 654.78 1117.17 706.09 1117.17 441.25 1117.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-82",
    points: "441.25 1013.62 389.95 1013.62 638.04 1013.62 689.34 1013.62 441.25 1013.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-82",
    points: "441.25 910.08 389.95 910.08 621.29 910.08 672.6 910.08 441.25 910.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-82",
    points: "441.25 806.53 389.95 806.53 604.55 806.53 655.85 806.53 441.25 806.53"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-65"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "M441.25,1349.21h-51.3c-3.64,0-6.58-3.14-6.58-7h51.3c0,3.86,2.94,7,6.58,7"
  })))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 383.37,
    y: 1331.25,
    width: 51.3,
    height: 10.95
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M739.58,1324.25c3.64,0,6.58,3.14,6.58,7v10.95c0,3.86-2.94,7-6.58,7h-298.33c-3.64,0-6.58-3.14-6.58-7v-10.95c0-3.86,2.94-7,6.58-7h298.33Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-30"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "M434.67,1331.25h-51.3c0-3.86,2.94-7,6.58-7h51.3c-3.64,0-6.58,3.14-6.58,7"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-37"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "M441.25,1245.66h-51.3c-3.64,0-6.58-3.13-6.58-7h51.3c0,3.87,2.94,7,6.58,7"
  })))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 383.37,
    y: 1227.71,
    width: 51.3,
    height: 10.95
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-32"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "M434.67,1227.71h-51.3c0-3.86,2.94-6.99,6.58-6.99h51.3c-3.64,0-6.58,3.13-6.58,6.99"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M722.83,1220.71c3.64,0,6.58,3.13,6.58,6.99v10.95c0,3.87-2.94,7-6.58,7h-281.58c-3.64,0-6.58-3.13-6.58-7v-10.95c0-3.86,2.94-6.99,6.58-6.99h281.58Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-36"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "M441.25,1142.12h-51.3c-3.64,0-6.58-3.13-6.58-7h51.3c0,3.87,2.94,7,6.58,7"
  })))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 383.37,
    y: 1124.17,
    width: 51.3,
    height: 10.94
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-34"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "M434.67,1124.17h-51.3c0-3.87,2.94-7,6.58-7h51.3c-3.64,0-6.58,3.13-6.58,7"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M706.09,1117.17c3.64,0,6.58,3.13,6.58,7v10.94c0,3.87-2.94,7-6.58,7h-264.84c-3.64,0-6.58-3.13-6.58-7v-10.94c0-3.87,2.94-7,6.58-7h264.84Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-31"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "M441.25,1038.57h-51.3c-3.64,0-6.58-3.13-6.58-7h51.3c0,3.87,2.94,7,6.58,7"
  })))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 383.37,
    y: 1020.63,
    width: 51.3,
    height: 10.94
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-35"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "M434.67,1020.63h-51.3c0-3.87,2.94-7,6.58-7h51.3c-3.64,0-6.58,3.13-6.58,7"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M689.34,1013.62c3.63,0,6.58,3.13,6.58,7v10.94c0,3.87-2.95,7-6.58,7h-248.09c-3.64,0-6.58-3.13-6.58-7v-10.94c0-3.87,2.94-7,6.58-7h248.09Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-33"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "M441.25,935.03h-51.3c-3.64,0-6.58-3.13-6.58-6.99h51.3c0,3.86,2.94,6.99,6.58,6.99"
  })))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 383.37,
    y: 917.08,
    width: 51.3,
    height: 10.95
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M672.6,910.08c3.63,0,6.58,3.13,6.58,7v10.95c0,3.86-2.95,6.99-6.58,6.99h-231.35c-3.64,0-6.58-3.13-6.58-6.99v-10.95c0-3.87,2.94-7,6.58-7h231.35Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-38"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "M434.67,917.08h-51.3c0-3.87,2.94-7,6.58-7h51.3c-3.64,0-6.58,3.13-6.58,7"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-39"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "M441.25,831.49h-51.3c-3.64,0-6.58-3.14-6.58-7h51.3c0,3.86,2.94,7,6.58,7"
  })))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 383.37,
    y: 813.54,
    width: 51.3,
    height: 10.95
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M655.85,806.53c3.63,0,6.57,3.14,6.57,7v10.95c0,3.86-2.94,7-6.57,7h-214.6c-3.64,0-6.58-3.14-6.58-7v-10.95c0-3.86,2.94-7,6.58-7h214.6Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-29"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "M434.67,813.54h-51.3c0-3.86,2.94-7,6.58-7h51.3c-3.64,0-6.58,3.14-6.58,7"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "357.49 303.31 306.19 303.31 423.56 303.31 474.86 303.31 357.49 303.31"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 306.19,
    y: 303.31,
    width: 51.3,
    height: 1083.45
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-82",
    points: "345.91 303.08 294.61 303.08 304.66 303.08 355.96 303.08 345.91 303.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "126.53 1725.23 75.23 1725.23 306.19 1386.76 357.49 1386.76 126.53 1725.23"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 294.61,
    y: 303.08,
    width: 51.3,
    height: 1090.67
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "355.96 303.08 355.96 1384.85 345.91 1393.76 345.91 303.08 355.96 303.08"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 75.23,
    y: 1725.23,
    width: 51.3,
    height: 80.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M823.2,1449.01l.51,355.92h-466.07s-231.11.5-231.11.5v-80.2l230.96-338.48V303.31h117.37s143.78,317.26,143.78,317.26l94.41,50.56,110.15,777.88ZM746.16,1342.2v-10.95c0-3.86-2.94-7.01-6.58-7.01h-298.33c-3.63,0-6.58,3.15-6.58,7.01v10.95c0,3.86,2.94,7,6.58,7h298.33c3.63,0,6.58-3.14,6.58-7M434.67,1227.71v10.95c0,3.87,2.94,7,6.58,7h281.59c3.63,0,6.58-3.13,6.58-7v-10.95c0-3.86-2.94-6.99-6.58-6.99h-281.59c-3.63,0-6.58,3.13-6.58,6.99M434.67,1124.17v10.94c0,3.87,2.94,7,6.58,7h264.84c3.63,0,6.58-3.13,6.58-7v-10.94c0-3.87-2.94-7-6.58-7h-264.84c-3.63,0-6.58,3.13-6.58,7M434.67,1020.62v10.94c0,3.87,2.94,7,6.58,7h248.09c3.63,0,6.58-3.13,6.58-7v-10.94c0-3.87-2.96-7-6.58-7h-248.09c-3.63,0-6.58,3.13-6.58,7M434.67,917.08v10.96c0,3.86,2.94,6.99,6.58,6.99h231.35c3.63,0,6.58-3.13,6.58-6.99v-10.96c0-3.87-2.95-7-6.58-7h-231.35c-3.63,0-6.58,3.13-6.58,7M434.67,813.53v10.96c0,3.86,2.94,7,6.58,7h214.6c3.63,0,6.57-3.14,6.57-7v-10.96c0-3.86-2.94-7-6.57-7h-214.6c-3.63,0-6.58,3.14-6.58,7"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "374.77 1422.86 369.64 1422.86 657.81 1422.86 662.94 1422.86 374.77 1422.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-102",
    points: "662.94 1422.86 662.94 1554.5 274.29 1554.5 374.77 1422.86 662.94 1422.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "274.29 1554.5 269.16 1554.5 369.64 1422.86 374.77 1422.86 274.29 1554.5"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "251.69 1595.58 246.56 1595.58 651.96 1595.58 657.09 1595.58 251.69 1595.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-102",
    points: "657.09 1595.58 657.09 1727.22 151.21 1727.22 251.69 1595.58 657.09 1595.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "151.21 1727.22 146.08 1727.22 246.56 1595.58 251.69 1595.58 151.21 1727.22"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgSlowMeteora);
export default __webpack_public_path__ + "static/media/bg-slow-meteora.473b2b2147b65858c94f8ac5441416c2.svg";
export { ForwardRef as ReactComponent };